/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 $(document).on("click", ".CollectionMenu__List--Link span.plus",function () {
  $(this).toggleClass("active");
  $(this)
    .parent("div")
    .next("ul")
    .slideToggle(400);
  return false;
});
// Coming Soonフォームsubmit無効化
// disabled属性に加え、フォームのsubmitイベントレベルでもカート追加を防止する。
// これによりdevtoolsで属性を書き換えたり、action改ざんを試みてもカート追加されない。
(function () {
  function guardComingSoonForms() {
    var forms = document.querySelectorAll('form.ProductForm');
    forms.forEach(function (form) {
      if (form.dataset.comingSoonGuarded) return;
      form.dataset.comingSoonGuarded = 'true';
      form.addEventListener('submit', function (event) {
        var btn = form.querySelector('[data-coming-soon="true"]');
        if (btn) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardComingSoonForms);
  } else {
    guardComingSoonForms();
  }
})();

// Coming Soonボタン状態の復元ガード
// theme.jsの_updateAddToCartButtonがvariant:changedイベントでComing Soonボタンを
// 上書きする問題を防止する。バリアント変更後にComing Soonボタンの状態を復元する。
// Note: variant:changedはsectionコンテナ要素から発火されるため、
// event.targetはform要素の祖先にあたり、closest('form')はnullを返す。
// querySelectorで子孫方向を検索する。
(function () {
  function restoreComingSoonButton(event) {
    var container = event.target;
    var btn = container.querySelector('.ProductForm__AddToCart[data-coming-soon="true"]');
    if (!btn) return;
    // Coming Soonボタンの状態を復元
    var label = btn.getAttribute('data-coming-soon-label') || btn.textContent.trim();
    btn.classList.add('ProductForm__AddToCart--comingSoon');
    btn.classList.remove('Button--primary');
    btn.classList.remove('Button--secondary');
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
    btn.removeAttribute('data-action');
    btn.textContent = label;
  }

  document.addEventListener('variant:changed', restoreComingSoonButton);
})();
